import React from 'react';
import './AppFooter.scss';
import company from '../../config/companyInfo';
import { getBuildLabel } from '../../config/appConfig';

function AppFooter() {
  return (
    <footer className="app-footer">
      <span>&copy; {company.legalName}</span>
      <span className="app-footer-sep">&middot;</span>
      <a href={company.links.privacyPolicy.url} target={company.links.privacyPolicy.target} rel="noopener noreferrer" className="app-footer-link">{company.links.privacyPolicy.label}</a>
      <span className="app-footer-sep">&middot;</span>
      <a href={company.links.cyberSecurity.url} target={company.links.cyberSecurity.target} rel="noopener noreferrer" className="app-footer-link">{company.links.cyberSecurity.label}</a>
      <span className="app-footer-sep">&middot;</span>
      <a href="mailto:support@esai.com" className="app-footer-link">support@esai.com</a>
      <span className="app-footer-build" title="Build identifier">{getBuildLabel()}</span>
    </footer>
  );
}

export default AppFooter;
